import axios, { AxiosResponse } from "axios";
import { Dispatch } from "react";
import moment from "moment";
import { Action } from "./types";
import { UPDATE_SHOULD_REQUEST_INSIGHTS } from "../../redux/modules/_BETA/requestSchedule";

/**
 * Load analysis data for a given array of sites over a specific time range
 *
 * @param dispatch
 * @param timeRange Over how many days should insights be retrieved
 * @param selectedSites Existing selections of sites
 */
export async function getOccurrences(
  dispatch: Dispatch<Action>,
  timeRange = 3,
  selectedSites: string[]
) {
  dispatch({ type: "LOAD_OCCURRENCES" });

  // HACK: This is to prevent any requests happening when they don't need to
  const store = require("../../client").store;
  store.dispatch({
    type: UPDATE_SHOULD_REQUEST_INSIGHTS,
    shouldRequestInsights: false,
  });

  try {
    const m = moment();
    // NOTE: Must be defined before `from` because moment is mutable
    const to = m.format("YYYY-MM-DD");
    const from = m.subtract(timeRange, "days").format("YYYY-MM-DD");

    // Make the request
    const endpoint = "/synco/ui/insights";
    const body = { sites: selectedSites, insightType: "insights" };
    const { data }: AxiosResponse<Insite.API.Insights> = await axios.post(
      endpoint,
      body,
      { params: { from, to } }
    );

    // Store the retrieved occurrences and data groups for later composition
    dispatch({ type: "LOAD_OCCURRENCES_SUCCESS", rawData: data });
  } catch (error) {
    // TODO: Dispatch error state
  }
}
